
import React, { useState, useEffect, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import {
  Search,
  Filter,
  Download,
  Upload,
  FileText,
  RefreshCw,
  FileSpreadsheet,
  Plus,
  Eye,
  Edit,
  Trash2,
  Calendar,
  User,
  Building,
  Clock,
  CheckCircle,
  XCircle,
  AlertCircle,
  Activity,
  TrendingUp,
  UserCheck,
  Timer,
  ChevronLeft,
  ChevronRight,
  X
} from "lucide-react";
import { format } from "date-fns";
import { fr } from "date-fns/locale";
import { toast } from "sonner";
import releveHeuresService from "../../services/releveHeuresService";
import RelevesHeures from "./RelevesHeures";




// Données mock pour la liste des relevés d'heures
const mockTimeSheets= [
  {
    id: "TS-20241209",
    weekNumber: 3,
    year: 2024,
    startDate: "09/12/2024",
    endDate: "15/12/2024",
    employeeName: "KUMBA MHRIA",
    employeePosition: "MANUTENTIONNAIRE",
    employeeCompany: "LES GARTRES",
    employeeId: "1412_5",
    clientName: "Dupont Construction",
    status: "a_saisir",
    totalHours: 23.0,
    lastUpdated: "09/12/2024 14:30"
  },
  {
    id: "TS-20241202",
    weekNumber: 2,
    year: 2024,
    startDate: "02/12/2024",
    endDate: "08/12/2024",
    employeeName: "KUMBA MHRIA",
    employeeCompany: "LES GARTRES",
    employeeId: "1412_5",
    clientName: "Dupont Construction",
    status: "integrated",
    totalHours: 35.5,
    lastUpdated: "08/12/2024 18:15"
  },
  {
    id: "TS-20241202-2",
    weekNumber: 2,
    year: 2024,
    startDate: "02/12/2024",
    endDate: "08/12/2024",
    employeeName: "MARTIN PHILIPPE",
    employeePosition: "ELECTRICIEN",
    employeeCompany: "ELECTRO PRO",
    employeeId: "1587_3",
    clientName: "Electricité Générale",
    status: "a_saisir",
    totalHours: 42.0,
    lastUpdated: "07/12/2024 12:00"
  },
  {
    id: "TS-20241125",
    weekNumber: 1,
    year: 2024,
    startDate: "25/11/2024",
    endDate: "01/12/2024",
    employeeName: "DUBOIS ALAIN",
    employeePosition: "MACON",
    employeeCompany: "BATIMENT PLUS",
    employeeId: "1632_7",
    clientName: "Habitat Construction",
    status: "a_valider",
    totalHours: 39.0,
    lastUpdated: "03/12/2024 09:45"
  },
  {
    id: "TS-20241125-2",
    weekNumber: 1,
    year: 2024,
    startDate: "25/11/2024",
    endDate: "01/12/2024",
    employeeName: "GARCIA SOPHIE",
    employeePosition: "SECRÉTAIRE",
    employeeCompany: "SECRETARIAT PRO",
    employeeId: "1729_4",
    clientName: "Cabinet Juridique Martin",
    status: "pending",
    totalHours: 28.5,
    lastUpdated: "28/11/2024 15:20"
  },
  {
    id: "TS-20241118",
    weekNumber: 52,
    year: 2023,
    startDate: "18/11/2024",
    endDate: "24/11/2024",
    employeeName: "LEROY THOMAS",
    employeePosition: "OPÉRATEUR",
    employeeCompany: "INDUSTRIE TECH",
    employeeId: "1845_2",
    clientName: "Usine Metallurgique",
    status: "pending",
    totalHours: 40.0,
    lastUpdated: "25/11/2024 10:30"
  },
    {
    id: "TS-20241111",
    weekNumber: 51,
    year: 2023,
    startDate: "11/11/2024",
    endDate: "17/11/2024",
    employeeName: "MARTIN LOUISE",
    employeePosition: "ASSISTANTE RH",
    employeeCompany: "RH EXPERTS",
    employeeId: "1901_8",
    clientName: "Groupe Santé Pro",
    status: "a_valider",
    totalHours: 37,
    lastUpdated: "18/11/2024 10:10"
  },
  {
    id: "TS-20241104",
    weekNumber: 50,
    year: 2023,
    startDate: "04/11/2024",
    endDate: "10/11/2024",
    employeeName: "BOUCHER LÉA",
    employeePosition: "COMPTABLE",
    employeeCompany: "COMPTA SERVICES",
    employeeId: "1902_9",
    clientName: "Cabinet Fiscal Dupuis",
    status: "pending",
    totalHours: 35,
    lastUpdated: "11/11/2024 09:00"
  },
  {
    id: "TS-20241028",
    weekNumber: 49,
    year: 2023,
    startDate: "28/10/2024",
    endDate: "03/11/2024",
    employeeName: "NGUYEN THI",
    employeePosition: "DÉVELOPPEUSE WEB",
    employeeCompany: "DEV & CO",
    employeeId: "1910_3",
    clientName: "Agence Digitale Webnova",
    status: "a_saisir",
    totalHours: 40,
    lastUpdated: "04/11/2024 17:30"
  },
  {
    id: "TS-20241021",
    weekNumber: 48,
    year: 2023,
    startDate: "21/10/2024",
    endDate: "27/10/2024",
    employeeName: "BEN ALI YASSINE",
    employeePosition: "TECHNICIEN IT",
    employeeCompany: "INFOTECH",
    employeeId: "1911_4",
    clientName: "Hôpital Saint-Michel",
    status: "a_valider",
    totalHours: 38.5,
    lastUpdated: "28/10/2024 08:45"
  },
  {
    id: "TS-20241014",
    weekNumber: 47,
    year: 2023,
    startDate: "14/10/2024",
    endDate: "20/10/2024",
    employeeName: "KIM JI-HOON",
    employeePosition: "CHEF DE PROJET",
    employeeCompany: "PMO SOLUTIONS",
    employeeId: "1912_5",
    clientName: "Banque Nationale",
    status: "pending",
    totalHours: 39,
    lastUpdated: "21/10/2024 09:15"
  },
  {
    id: "TS-20241007",
    weekNumber: 46,
    year: 2023,
    startDate: "07/10/2024",
    endDate: "13/10/2024",
    employeeName: "LAMBERT JULIEN",
    employeePosition: "INGÉNIEUR SÉCURITÉ",
    employeeCompany: "CYBERPRO",
    employeeId: "1913_6",
    clientName: "Ministère de la Défense",
    status: "integrated",
    totalHours: 41,
    lastUpdated: "14/10/2024 16:10"
  },
  {
    id: "TS-20241001",
    weekNumber: 45,
    year: 2023,
    startDate: "30/09/2024",
    endDate: "06/10/2024",
    employeeName: "OLIVIER ANNE",
    employeePosition: "SECRÉTAIRE",
    employeeCompany: "BUREAUTIQUE PRO",
    employeeId: "1914_7",
    clientName: "Association Locale",
    status: "a_saisir",
    totalHours: 32,
    lastUpdated: "07/10/2024 13:00"
  },
  {
    id: "TS-20240924",
    weekNumber: 44,
    year: 2023,
    startDate: "23/09/2024",
    endDate: "29/09/2024",
    employeeName: "TOURE MAMADOU",
    employeePosition: "MAGASINIER",
    employeeCompany: "LOGISTIX",
    employeeId: "1915_8",
    clientName: "Centrale d’Achat Nord",
    status: "a_valider",
    totalHours: 40,
    lastUpdated: "30/09/2024 11:00"
  },
  {
    id: "TS-20240917",
    weekNumber: 43,
    year: 2023,
    startDate: "16/09/2024",
    endDate: "22/09/2024",
    employeeName: "FERRARI LUCA",
    employeePosition: "CARRELEUR",
    employeeCompany: "BATIRAPIDE",
    employeeId: "1916_9",
    clientName: "Immobilier Vinci",
    status: "pending",
    totalHours: 36.5,
    lastUpdated: "23/09/2024 07:45"
  },
  {
    id: "TS-20240910",
    weekNumber: 42,
    year: 2023,
    startDate: "09/09/2024",
    endDate: "15/09/2024",
    employeeName: "ZHANG MEI",
    employeePosition: "GRAPHISTE",
    employeeCompany: "CREA STUDIO",
    employeeId: "1917_0",
    clientName: "Startup X",
    status: "integrated",
    totalHours: 34,
    lastUpdated: "16/09/2024 14:50"
  },
  {
    id: "TS-20240903",
    weekNumber: 41,
    year: 2023,
    startDate: "02/09/2024",
    endDate: "08/09/2024",
    employeeName: "DIALLO FATOU",
    employeePosition: "AGENTE D'ENTRETIEN",
    employeeCompany: "PROPRETÉ URBAINE",
    employeeId: "1920_1",
    clientName: "Mairie de Lyon",
    status: "a_saisir",
    totalHours: 30,
    lastUpdated: "09/09/2024 10:30"
  },
  {
    id: "TS-20240827",
    weekNumber: 40,
    year: 2023,
    startDate: "26/08/2024",
    endDate: "01/09/2024",
    employeeName: "MOREAU HUGO",
    employeePosition: "LIVREUR",
    employeeCompany: "EXPRESS LIVRAISON",
    employeeId: "1921_2",
    clientName: "E-commerce Rapid",
    status: "pending",
    totalHours: 39.5,
    lastUpdated: "02/09/2024 09:45"
  },
  {
    id: "TS-20240820",
    weekNumber: 39,
    year: 2023,
    startDate: "19/08/2024",
    endDate: "25/08/2024",
    employeeName: "PETIT LÉA",
    employeePosition: "ASSISTANTE MARKETING",
    employeeCompany: "MARKETPRO",
    employeeId: "1922_3",
    clientName: "Vente Privée SAS",
    status: "a_valider",
    totalHours: 37,
    lastUpdated: "26/08/2024 15:00"
  },
  {
    id: "TS-20240813",
    weekNumber: 38,
    year: 2023,
    startDate: "12/08/2024",
    endDate: "18/08/2024",
    employeeName: "CHEIKH NDIAYE",
    employeePosition: "CHAUFFEUR PL",
    employeeCompany: "TRANSPORT 75",
    employeeId: "1923_4",
    clientName: "BTP Livraison",
    status: "a_saisir",
    totalHours: 40,
    lastUpdated: "19/08/2024 11:20"
  },
  {
    id: "TS-20240806",
    weekNumber: 37,
    year: 2023,
    startDate: "05/08/2024",
    endDate: "11/08/2024",
    employeeName: "GIRARD ÉLISE",
    employeePosition: "STANDARDISTE",
    employeeCompany: "ACCUEIL PRO",
    employeeId: "1924_5",
    clientName: "Cabinet Médical Pasteur",
    status: "pending",
    totalHours: 28,
    lastUpdated: "12/08/2024 08:00"
  },
    {
    id: "TS-20240730",
    weekNumber: 36,
    year: 2023,
    startDate: "29/07/2024",
    endDate: "04/08/2024",
    employeeName: "GONZALEZ MARIA",
    employeePosition: "RÉCEPTIONNISTE",
    employeeCompany: "ACCUEIL SERVICES",
    employeeId: "1930_1",
    clientName: "Hôtel Central",
    status: "pending",
    totalHours: 31.5,
    lastUpdated: "05/08/2024 09:30"
  },
  {
    id: "TS-20240723",
    weekNumber: 35,
    year: 2023,
    startDate: "22/07/2024",
    endDate: "28/07/2024",
    employeeName: "LEFEBVRE PIERRE",
    employeePosition: "AGENT DE SÉCURITÉ",
    employeeCompany: "SECURITÉ PLUS",
    employeeId: "1931_2",
    clientName: "Centre Commercial Nord",
    status: "pending",
    totalHours: 40,
    lastUpdated: "29/07/2024 14:00"
  },
  {
    id: "TS-20240716",
    weekNumber: 34,
    year: 2023,
    startDate: "15/07/2024",
    endDate: "21/07/2024",
    employeeName: "KONE ISMAËL",
    employeePosition: "AGENT LOGISTIQUE",
    employeeCompany: "DISTRILOG",
    employeeId: "1932_3",
    clientName: "Amazon France",
    status: "pending",
    totalHours: 38.5,
    lastUpdated: "22/07/2024 16:20"
  }
];



export default function RelevesHeuresListe() {
  // États du composant
  const navigate = useNavigate();
  const [timesheets, setTimesheets] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState("");
  const [currentTab, setCurrentTab] = useState("all");
  const [sortField, setSortField] = useState("lastUpdated");
  const [sortDirection, setSortDirection] = useState("desc");
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 20;

  // État pour afficher le relevé d'heures en overlay
  const [selectedTimesheetId, setSelectedTimesheetId] = useState(null);
  const [selectedTimesheet, setSelectedTimesheet] = useState(null);

  // États pour la navigation par semaine
  const [currentWeekStart, setCurrentWeekStart] = useState(() => {
    // Obtenir le lundi de la semaine courante
    const today = new Date();
    const day = today.getDay();
    const diff = today.getDate() - day + (day === 0 ? -6 : 1); // Ajuster si dimanche
    const monday = new Date(today);
    monday.setDate(diff);
    return monday;
  });

  const [currentWeekEnd, setCurrentWeekEnd] = useState(() => {
    // Obtenir le dimanche de la semaine courante
    const today = new Date();
    const day = today.getDay();
    const diff = today.getDate() - day + (day === 0 ? 0 : 7); // Dimanche
    const sunday = new Date(today);
    sunday.setDate(diff);
    return sunday;
  });

  // Charger les relevés d'heures au démarrage
  useEffect(() => {
    loadTimesheets();
  }, []);

  // Fonction pour charger les relevés d'heures depuis l'API
  const loadTimesheets = async () => {
    try {
      setIsLoading(true);
      const data = await releveHeuresService.getAllForClient();

      // Transformer les données du backend au format attendu par le frontend
      const transformedData = data.map(transformBackendToFrontend);
      setTimesheets(transformedData);

      toast.success(`${transformedData.length} relevé(s) d'heures chargé(s)`);
    } catch (error) {
      console.error('Erreur lors du chargement des relevés:', error);
      // En cas d'erreur, utiliser les données mock
      setTimesheets(mockTimeSheets);
      toast.error('Erreur lors du chargement des relevés d\'heures');
    } finally {
      setIsLoading(false);
    }
  };

  // Fonction pour transformer les données du backend au format frontend
  const transformBackendToFrontend = (backendData) => {
    // Calculer le total des heures depuis TabJours
    let totalHours = 0;
    if (backendData.TabJours && Array.isArray(backendData.TabJours)) {
      backendData.TabJours.forEach(jour => {
        totalHours += parseFloat(jour.NbHeureJour || 0);
        totalHours += parseFloat(jour.NbHeureNuit || 0);
      });
    }

    // Fonction pour parser les dates au format YYYYMMDD
    const parseBackendDate = (dateString) => {
      if (!dateString) return null;
      // Format: "20251110" -> YYYYMMDD
      const year = parseInt(dateString.substring(0, 4));
      const month = parseInt(dateString.substring(4, 6)) - 1; // Les mois commencent à 0
      const day = parseInt(dateString.substring(6, 8));
      return new Date(year, month, day);
    };

    // Calculer le numéro de semaine
    const getWeekNumber = (date) => {
      if (!date || isNaN(date.getTime())) return 0;
      const d = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()));
      const dayNum = d.getUTCDay() || 7;
      d.setUTCDate(d.getUTCDate() + 4 - dayNum);
      const yearStart = new Date(Date.UTC(d.getUTCFullYear(), 0, 1));
      return Math.ceil((((d - yearStart) / 86400000) + 1) / 7);
    };

    // Parser les dates du backend (format YYYYMMDD)
    const startDate = parseBackendDate(backendData.DateDebut);
    const endDate = parseBackendDate(backendData.DateFin);

    // Nettoyer l'ID en enlevant tout ce qui suit ":" si présent
    const cleanId = backendData._id ? String(backendData._id).split(':')[0] : backendData._id;

    return {
      id: cleanId,
      weekNumber: startDate ? getWeekNumber(startDate) : 0,
      year: startDate ? startDate.getFullYear() : new Date().getFullYear(),
      startDate: formatDateToString(startDate),
      endDate: formatDateToString(endDate),
      employeeName: backendData.NomPrenom || "",
      employeePosition: backendData.Profession || "",
      employeeCompany: backendData.RaisonSociale || "",
      employeeId: backendData.IdInterimaire || "",
      clientName: backendData.RaisonSociale || "",
      status: backendData.status || "pending",
      totalHours: totalHours,
      lastUpdated: backendData.updatedAt || backendData.createdAt || new Date().toISOString(),
      contractNumber: backendData.NumeroContrat || "",
      avenant: backendData.NumeroAvenant || ""
    };
  };

  // Fonction helper pour formater les dates
  const formatDateToString = (date) => {
    if (!date) return "";

    // Si c'est déjà un objet Date
    if (date instanceof Date) {
      if (isNaN(date.getTime())) return "";
      const day = String(date.getDate()).padStart(2, '0');
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const year = date.getFullYear();
      return `${day}/${month}/${year}`;
    }

    // Sinon, essayer de le convertir
    const d = new Date(date);
    if (isNaN(d.getTime())) return "";
    const day = String(d.getDate()).padStart(2, '0');
    const month = String(d.getMonth() + 1).padStart(2, '0');
    const year = d.getFullYear();
    return `${day}/${month}/${year}`;
  };

  // Animation variants
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        duration: 0.3,
        staggerChildren: 0.1
      }
    }
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.3 }
    }
  };

  // Fonctions utilitaires
  const formatDate = (dateString) => {
    if (!dateString) return "-";
    try {
      const date = new Date(dateString);
      if (isNaN(date.getTime())) return "-";
      return format(date, "dd/MM/yyyy", { locale: fr });
    } catch (error) {
      return "-";
    }
  };

  const formatDateTime = (dateString) => {
    if (!dateString) return "-";
    try {
      const date = new Date(dateString);
      if (isNaN(date.getTime())) return "-";
      return format(date, "dd/MM/yyyy 'à' HH:mm", { locale: fr });
    } catch (error) {
      return "-";
    }
  };

  // Fonction pour obtenir le statut d'un relevé
  const getTimesheetStatut = (timesheet) => {
    return timesheet.status;
  };

  // Fonction pour obtenir le libellé du statut en français
  const getStatusLabel = (status) => {
    switch(status) {
      case "pending":
        return "En attente";
      case "a_saisir":
        return "À saisir";
      case "a_valider":
        return "À valider";
      case "integrated":
        return "Intégré";
      default:
        return status;
    }
  };

  // Fonction pour vérifier si un relevé est dans la semaine courante
  const isInCurrentWeek = (timesheet) => {
    if (!timesheet.startDate) return false;

    try {
      // Parser la date de début du relevé (format DD/MM/YYYY)
      const [dayStart, monthStart, yearStart] = timesheet.startDate.split('/');
      const timesheetStartDate = new Date(yearStart, monthStart - 1, dayStart);

      // Parser la date de fin du relevé (format DD/MM/YYYY)
      let timesheetEndDate = timesheetStartDate;
      if (timesheet.endDate) {
        const [dayEnd, monthEnd, yearEnd] = timesheet.endDate.split('/');
        timesheetEndDate = new Date(yearEnd, monthEnd - 1, dayEnd);
      }

      // Vérifier si la période du relevé chevauche la semaine sélectionnée
      // Un relevé est dans la semaine si :
      // - Sa date de début est avant ou pendant la semaine ET
      // - Sa date de fin est pendant ou après le début de la semaine
      return timesheetStartDate <= currentWeekEnd && timesheetEndDate >= currentWeekStart;
    } catch (error) {
      console.error('Erreur lors du parsing de la date:', timesheet.startDate, error);
      return false;
    }
  };

  // Calcul des totaux pour l'affichage des statistiques (uniquement pour la semaine courante)
  const totaux = useMemo(() => {
    // Filtrer les relevés de la semaine courante
    const weekTimesheets = timesheets.filter(isInCurrentWeek);

    if (!weekTimesheets.length) {
      return {
        totalRelevesHeures: 0,
        relevesASaisir: 0,
        relevesAValider: 0,
        relevesEnAttente: 0,
        relevesIntegres: 0,
        totalHeures: 0
      };
    }

    const totalHeures = weekTimesheets.reduce((acc, timesheet) => acc + (timesheet.totalHours || 0), 0);
    const relevesASaisir = weekTimesheets.filter(t => t.status === "a_saisir").length;
    const relevesAValider = weekTimesheets.filter(t => t.status === "a_valider").length;
    const relevesEnAttente = weekTimesheets.filter(t => t.status === "pending").length;
    const relevesIntegres = weekTimesheets.filter(t => t.status === "integrated").length;

    return {
      totalRelevesHeures: weekTimesheets.length,
      relevesASaisir,
      relevesAValider,
      relevesEnAttente,
      relevesIntegres,
      totalHeures: totalHeures.toFixed(1)
    };
  }, [timesheets, currentWeekStart, currentWeekEnd]);

  const removeDiacritics = (str) =>
    str?.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "");
  // Fonction de tri
  const handleSort = (field) => {
    if (sortField === field) {
      setSortDirection(sortDirection === "asc" ? "desc" : "asc");
    } else {
      setSortField(field);
      setSortDirection("asc");
    }
  };

  // Fonction pour naviguer entre les semaines
  const navigateWeek = (direction) => {
    const newStart = new Date(currentWeekStart);
    const newEnd = new Date(currentWeekEnd);

    if (direction === "prev") {
      newStart.setDate(newStart.getDate() - 7);
      newEnd.setDate(newEnd.getDate() - 7);
    } else {
      newStart.setDate(newStart.getDate() + 7);
      newEnd.setDate(newEnd.getDate() + 7);
    }

    setCurrentWeekStart(newStart);
    setCurrentWeekEnd(newEnd);
  };

  // Fonction pour aller à la semaine courante
  const goToCurrentWeek = () => {
    const today = new Date();
    const day = today.getDay();
    const diffStart = today.getDate() - day + (day === 0 ? -6 : 1);
    const diffEnd = today.getDate() - day + (day === 0 ? 0 : 7);

    const newStart = new Date(today);
    newStart.setDate(diffStart);

    const newEnd = new Date(today);
    newEnd.setDate(diffEnd);

    setCurrentWeekStart(newStart);
    setCurrentWeekEnd(newEnd);
  };

  // Calcul des relevés filtrés et triés
  const filteredTimesheets = timesheets
    .filter((timesheet) => {
      // Filtre par semaine
      if (!isInCurrentWeek(timesheet)) return false;

      const statut = getTimesheetStatut(timesheet);

      // Filtre par onglet
      if (currentTab === "a_saisir" && statut !== "a_saisir") return false;
      if (currentTab === "a_valider" && statut !== "a_valider") return false;
      if (currentTab === "pending" && statut !== "pending") return false;
      if (currentTab === "integrated" && statut !== "integrated") return false;

      // Si champ vide, on garde tout
      if (searchTerm === "") return true;

      const search = searchTerm.toLowerCase();

      // Recherche dans tous les champs pertinents
      return (
        timesheet.employeeName?.toLowerCase().includes(search) ||
        timesheet.employeePosition?.toLowerCase().includes(search) ||
        timesheet.clientName?.toLowerCase().includes(search) ||
        timesheet.employeeCompany?.toLowerCase().includes(search)
      );
    })
    .sort((a, b) => {
      if (!sortField) return 0;

      let valueA, valueB;

      switch (sortField) {
        case "employeeName":
          valueA = a.employeeName;
          valueB = b.employeeName;
          break;
        case "status":
          valueA = getTimesheetStatut(a);
          valueB = getTimesheetStatut(b);
          break;
        case "totalHours":
          valueA = a.totalHours || 0;
          valueB = b.totalHours || 0;
          break;
        case "lastUpdated":
          valueA = a.lastUpdated;
          valueB = b.lastUpdated;
          break;
        case "clientName":
          valueA = a.clientName;
          valueB = b.clientName;
          break;
        default:
          valueA = a[sortField];
          valueB = b[sortField];
      }

      // Comparaison de dates
      if (sortField === "lastUpdated") {
        const dateA = valueA ? new Date(valueA) : null;
        const dateB = valueB ? new Date(valueB) : null;

        valueA = dateA && !isNaN(dateA.getTime()) ? dateA.getTime() : 0;
        valueB = dateB && !isNaN(dateB.getTime()) ? dateB.getTime() : 0;
      }

      if (valueA < valueB) return sortDirection === "asc" ? -1 : 1;
      if (valueA > valueB) return sortDirection === "asc" ? 1 : -1;
      return 0;
    });
  
  const totalPages = Math.ceil(filteredTimesheets.length / itemsPerPage);

  // S'assurer que currentPage est dans les limites valides
  const validCurrentPage = Math.max(1, Math.min(currentPage, totalPages || 1));

  // Si la page actuelle n'est pas valide, la corriger
  if (validCurrentPage !== currentPage && totalPages > 0) {
    setCurrentPage(validCurrentPage);
  }

  const startIndex = (validCurrentPage - 1) * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;
  const paginatedTimesheets = filteredTimesheets.slice(startIndex, endIndex);

  // Fonctions pour les actions
  const viewTimesheet = (id) => {
    // Trouver le relevé complet dans la liste
    const timesheet = timesheets.find(ts => ts._id === id);

    // Afficher en overlay au lieu de naviguer
    setSelectedTimesheetId(id);
    setSelectedTimesheet(timesheet);
  };

  // Fonction pour fermer l'overlay
  const closeTimesheetOverlay = () => {
    setSelectedTimesheetId(null);
    setSelectedTimesheet(null);
    // Recharger la liste pour avoir les données à jour
    loadTimesheets();
  };

  const handleExportExcel = () => {
    toast.success("Export Excel en cours de développement");
  };

  // Afficher un écran de chargement initial
  if (isLoading && timesheets.length === 0) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-16 w-16 border-b-2 border-blue-500 mx-auto mb-4"></div>
          <p className="text-slate-600 text-lg">Chargement des relevés d'heures...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen">
      <motion.div
        className="container mx-auto py-8 px-4"
        variants={containerVariants}
        initial="hidden"
        animate="visible"
      >
        {/* En-tête moderne */}
        <motion.div
          className="mb-8"
          variants={itemVariants}
        >
          <div className="flex items-center justify-between mb-4">
            <div className="flex items-center space-x-4">
              <div className="p-3 bg-gradient-to-r from-blue-500 to-purple-600 rounded-xl shadow-lg">
                <Clock size={32} className="text-white" />
              </div>
              <div>
                <h1 className="text-4xl font-bold bg-gradient-to-r from-slate-800 to-slate-600 bg-clip-text text-transparent">
                  Relevés d'Heures
                </h1>
                <p className="text-slate-600 mt-1">
                  Consultez et gérez tous les relevés d'heures en temps réel
                </p>
              </div>
            </div>
          </div>

          {/* Navigation par semaine */}
          <div className="bg-white rounded-xl shadow-sm border border-slate-200 p-4">
            <div className="flex items-center justify-between">
              <button
                onClick={() => navigateWeek("prev")}
                className="flex items-center space-x-2 px-4 py-2 bg-slate-100 hover:bg-slate-200 text-slate-700 rounded-lg transition-colors"
              >
                <ChevronLeft size={20} />
                <span className="font-medium">Semaine précédente</span>
              </button>

              <div className="flex flex-col items-center">
                <div className="flex items-center space-x-2 text-slate-700">
                  <Calendar size={20} className="text-blue-600" />
                  <span className="text-lg font-semibold">
                    Semaine du {format(currentWeekStart, 'dd MMMM', { locale: fr })} au {format(currentWeekEnd, 'dd MMMM yyyy', { locale: fr })}
                  </span>
                </div>
                <button
                  onClick={goToCurrentWeek}
                  className="mt-2 text-sm text-blue-600 hover:text-blue-700 font-medium"
                >
                  Aller à la semaine courante
                </button>
              </div>

              <button
                onClick={() => navigateWeek("next")}
                className="flex items-center space-x-2 px-4 py-2 bg-slate-100 hover:bg-slate-200 text-slate-700 rounded-lg transition-colors"
              >
                <span className="font-medium">Semaine suivante</span>
                <ChevronRight size={20} />
              </button>
            </div>
          </div>
        </motion.div>

        {/* Statistiques modernes */}
        <motion.div
          className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-8"
          variants={itemVariants}
        >
          {/* Total Relevés */}
          <div className="bg-white rounded-xl shadow-sm border border-slate-200 p-6 hover:shadow-md transition-all duration-300">
            <div className="flex items-center justify-between">
              <div>
                <p className="text-slate-600 text-sm font-medium">Relevés cette semaine</p>
                <p className="text-3xl font-bold text-slate-800 mt-1">{totaux.totalRelevesHeures}</p>
                <p className="text-blue-600 text-sm mt-1 flex items-center">
                  <Activity size={16} className="mr-1" />
                  {totaux.totalHeures}h au total
                </p>
              </div>
              <div className="p-3 bg-blue-100 rounded-xl">
                <FileText size={24} className="text-blue-600" />
              </div>
            </div>
          </div>

          {/* À Saisir */}
          <div className="bg-white rounded-xl shadow-sm border border-slate-200 p-6 hover:shadow-md transition-all duration-300">
            <div className="flex items-center justify-between">
              <div>
                <p className="text-slate-600 text-sm font-medium">À Saisir</p>
                <p className="text-3xl font-bold text-red-600 mt-1">{totaux.relevesEnAttente}</p>
                <p className="text-red-600 text-sm mt-1 flex items-center">
                  <AlertCircle size={16} className="mr-1" />
                  Action requise
                </p>
              </div>
              <div className="p-3 bg-red-100 rounded-xl">
                <AlertCircle size={24} className="text-red-600" />
              </div>
            </div>
          </div>

          {/* À Valider */}
          <div className="bg-white rounded-xl shadow-sm border border-slate-200 p-6 hover:shadow-md transition-all duration-300">
            <div className="flex items-center justify-between">
              <div>
                <p className="text-slate-600 text-sm font-medium">À Valider</p>
                <p className="text-3xl font-bold text-orange-600 mt-1">{totaux.relevesAValider}</p>
                <p className="text-orange-600 text-sm mt-1 flex items-center">
                  <Clock size={16} className="mr-1" />
                  En attente validation
                </p>
              </div>
              <div className="p-3 bg-orange-100 rounded-xl">
                <Clock size={24} className="text-orange-600" />
              </div>
            </div>
          </div>

          {/* Intégrés */}
          <div className="bg-white rounded-xl shadow-sm border border-slate-200 p-6 hover:shadow-md transition-all duration-300">
            <div className="flex items-center justify-between">
              <div>
                <p className="text-slate-600 text-sm font-medium">Intégrés</p>
                <p className="text-3xl font-bold text-green-600 mt-1">{totaux.relevesIntegres}</p>
                <p className="text-green-600 text-sm mt-1 flex items-center">
                  <CheckCircle size={16} className="mr-1" />
                  Terminés
                </p>
              </div>
              <div className="p-3 bg-green-100 rounded-xl">
                <CheckCircle size={24} className="text-green-600" />
              </div>
            </div>
          </div>
        </motion.div>
        {/* Filtres et recherche modernes */}
        <motion.div
          className="bg-white rounded-xl shadow-sm border border-slate-200 p-6 mb-8"
          variants={itemVariants}
        >
          <div className="space-y-4">
            {/* Onglets de filtrage */}
            <div className="flex flex-wrap gap-2 bg-slate-100 p-1 rounded-xl">
              <button
                onClick={() => {
                  setCurrentTab("all");
                  setCurrentPage(1);
                }}
                className={`px-4 py-2.5 rounded-lg font-medium transition-all duration-200 ${
                  currentTab === "all"
                    ? "bg-white text-slate-800 shadow-md"
                    : "text-slate-600 hover:text-slate-800"
                }`}
              >
                <div className="flex items-center space-x-2">
                  <FileText size={18} />
                  <span>Tous ({totaux.totalRelevesHeures})</span>
                </div>
              </button>
              <button
                onClick={() => {
                  setCurrentTab("a_saisir");
                  setCurrentPage(1);
                }}
                className={`px-4 py-2.5 rounded-lg font-medium transition-all duration-200 ${
                  currentTab === "a_saisir"
                    ? "bg-white text-slate-800 shadow-md"
                    : "text-slate-600 hover:text-slate-800"
                }`}
              >
                <div className="flex items-center space-x-2">
                  <AlertCircle size={18} />
                  <span>À saisir ({totaux.relevesASaisir})</span>
                </div>
              </button>
              <button
                onClick={() => {
                  setCurrentTab("a_valider");
                  setCurrentPage(1);
                }}
                className={`px-4 py-2.5 rounded-lg font-medium transition-all duration-200 ${
                  currentTab === "a_valider"
                    ? "bg-white text-slate-800 shadow-md"
                    : "text-slate-600 hover:text-slate-800"
                }`}
              >
                <div className="flex items-center space-x-2">
                  <Clock size={18} />
                  <span>À valider ({totaux.relevesAValider})</span>
                </div>
              </button>
              <button
                onClick={() => {
                  setCurrentTab("integrated");
                  setCurrentPage(1);
                }}
                className={`px-4 py-2.5 rounded-lg font-medium transition-all duration-200 ${
                  currentTab === "integrated"
                    ? "bg-white text-slate-800 shadow-md"
                    : "text-slate-600 hover:text-slate-800"
                }`}
              >
                <div className="flex items-center space-x-2">
                  <CheckCircle size={18} />
                  <span>Intégrés ({totaux.relevesIntegres})</span>
                </div>
              </button>
            </div>

            {/* Barre de recherche et actions */}
            <div className="flex flex-col sm:flex-row gap-3">
              <div className="relative flex-1">
                <Search size={20} className="absolute left-3 top-1/2 transform -translate-y-1/2 text-slate-400" />
                <input
                  type="text"
                  placeholder="Rechercher par employé, poste, client..."
                  value={searchTerm}
                  onChange={(e) => {
                    setSearchTerm(e.target.value);
                    setCurrentPage(1);
                  }}
                  className="pl-10 pr-10 py-2.5 w-full bg-slate-50 border border-slate-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200"
                />
                {searchTerm && (
                  <button
                    className="absolute right-3 top-1/2 transform -translate-y-1/2 text-slate-400 hover:text-slate-600 transition-colors"
                    onClick={() => setSearchTerm("")}
                    title="Effacer"
                  >
                    <XCircle size={16} />
                  </button>
                )}
              </div>

              <div className="flex gap-2">
                <button
                  onClick={loadTimesheets}
                  disabled={isLoading}
                  className="flex items-center space-x-2 px-4 py-2.5 bg-blue-500 text-white rounded-xl hover:bg-blue-600 transition-colors whitespace-nowrap disabled:opacity-50 disabled:cursor-not-allowed"
                >
                  <RefreshCw size={18} className={isLoading ? "animate-spin" : ""} />
                  <span className="hidden sm:inline">Actualiser</span>
                </button>

                <button
                  onClick={handleExportExcel}
                  className="flex items-center space-x-2 px-4 py-2.5 bg-emerald-500 text-white rounded-xl hover:bg-emerald-600 transition-colors whitespace-nowrap"
                  title="Exporter vers Excel"
                >
                  <FileSpreadsheet size={18} />
                  <span className="hidden sm:inline">Export Excel</span>
                </button>
              </div>
            </div>
          </div>
        </motion.div>

        {/* Liste des relevés d'heures en cards modernes */}
        <motion.div
          className="space-y-4"
          variants={itemVariants}
        >
          {isLoading ? (
            <div className="flex justify-center items-center py-12">
              <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-500"></div>
            </div>
          ) : filteredTimesheets.length === 0 ? (
            <div className="bg-white rounded-xl shadow-sm border border-slate-200 p-12 text-center">
              <Clock size={48} className="mx-auto text-slate-400 mb-4" />
              <h3 className="text-xl font-semibold text-slate-600 mb-2">Aucun relevé d'heures trouvé</h3>
              <p className="text-slate-500">
                {searchTerm
                  ? "Aucun relevé ne correspond à votre recherche pour cette semaine."
                  : `Aucun relevé d'heures disponible pour la semaine du ${format(currentWeekStart, 'dd MMMM', { locale: fr })} au ${format(currentWeekEnd, 'dd MMMM yyyy', { locale: fr })}.`}
              </p>
            </div>
          ) : (
            <AnimatePresence>
              {paginatedTimesheets.map((timesheet, index) => (
                <motion.div
                  key={timesheet.id}
                  className="bg-white rounded-xl shadow-sm border border-slate-200 p-6 hover:shadow-md transition-all duration-300"
                  variants={itemVariants}
                  initial="hidden"
                  animate="visible"
                  exit="hidden"
                  layout
                  transition={{ delay: index * 0.05 }}
                >
                  <div className="grid grid-cols-1 xl:grid-cols-7 lg:grid-cols-3 md:grid-cols-2 gap-4 items-center">
                    {/* Employé */}
                    <div className="flex items-center space-x-3 min-w-0">
                      <div className="p-2 bg-blue-100 rounded-lg flex-shrink-0">
                        <User size={20} className="text-blue-600" />
                      </div>
                      <div className="min-w-0 flex-1">
                        <p className="font-semibold text-slate-800 truncate">{timesheet.employeeName}</p>
                        <p className="text-sm text-slate-500">{timesheet.employeePosition}</p>
                        <p className="text-xs text-slate-400">{timesheet.employeeCompany}</p>
                        <p className="text-sm font-semibold text-blue-900">Contrat {timesheet.contractNumber}.{timesheet.avenant}</p>
                      </div>
                    </div>

                    {/* Client */}
                    <div className="flex items-center space-x-3 min-w-0">
                      <div className="p-2 bg-purple-100 rounded-lg flex-shrink-0">
                        <Building size={20} className="text-purple-600" />
                      </div>
                      <div className="min-w-0 flex-1">
                        <p className="font-semibold text-slate-800 truncate">{timesheet.clientName}</p>
                        <p className="text-sm text-slate-500">Client</p>
                      </div>
                    </div>

                    {/* Période */}
                    <div className="flex items-center space-x-3 min-w-0">
                      <div className="p-2 bg-indigo-100 rounded-lg flex-shrink-0">
                        <Calendar size={20} className="text-indigo-600" />
                      </div>
                      <div className="min-w-0 flex-1">
                        <p className="font-semibold text-slate-800">{timesheet.startDate}</p>
                        <p className="text-sm text-slate-500">au {timesheet.endDate}</p>
                      </div>
                    </div>

                    {/* Heures */}
                    <div className="flex items-center space-x-3 min-w-0">
                      <div className="p-2 bg-emerald-100 rounded-lg flex-shrink-0">
                        <Timer size={20} className="text-emerald-600" />
                      </div>
                      <div className="min-w-0 flex-1">
                        <p className="font-semibold text-slate-800">{timesheet.totalHours}h</p>
                        <p className="text-sm text-slate-500">Total heures</p>
                      </div>
                    </div>

                    {/* Statut */}
                    <div className="flex items-center space-x-3 min-w-0">
                      <div className={`p-2 rounded-lg flex-shrink-0 ${
                        timesheet.status === "integrated"
                          ? "bg-emerald-100"
                          : timesheet.status === "a_valider"
                          ? "bg-orange-100"
                          : timesheet.status === "pending"
                          ? "bg-yellow-100"
                          : "bg-red-100"
                      }`}>
                        {timesheet.status === "integrated" ? (
                          <CheckCircle size={20} className="text-emerald-600" />
                        ) : timesheet.status === "a_valider" ? (
                          <Clock size={20} className="text-orange-600" />
                        ) : timesheet.status === "pending" ? (
                          <Timer size={20} className="text-yellow-600" />
                        ) : (
                          <AlertCircle size={20} className="text-red-600" />
                        )}
                      </div>
                      <div className="min-w-0 flex-1">
                        <div className={`inline-flex items-center px-2 py-1 rounded-full text-xs font-medium ${
                          timesheet.status === "integrated"
                            ? "bg-emerald-100 text-emerald-800"
                            : timesheet.status === "a_valider"
                            ? "bg-orange-100 text-orange-800"
                            : timesheet.status === "pending"
                            ? "bg-yellow-100 text-yellow-800"
                            : "bg-red-100 text-red-800"
                        }`}>
                          {getStatusLabel(timesheet.status)}
                        </div>
                        <p className="text-xs text-slate-500 mt-1">
                          Mis à jour: {formatDateTime(timesheet.lastUpdated)}
                        </p>
                      </div>
                    </div>

                    {/* Semaine */}
                    <div className="flex items-center space-x-3 min-w-0">
                      <div className="p-2 bg-slate-100 rounded-lg flex-shrink-0">
                        <Calendar size={20} className="text-slate-600" />
                      </div>
                      <div className="min-w-0 flex-1">
                        <p className="font-semibold text-slate-800">S{timesheet.weekNumber}</p>
                        <p className="text-sm text-slate-500">{timesheet.year}</p>
                      </div>
                    </div>

                    {/* Actions */}
                    <div className="flex items-center justify-end space-x-2 flex-shrink-0">
                      <button
                        onClick={() => viewTimesheet(timesheet.id)}
                        className="p-2 text-blue-600 hover:bg-blue-100 rounded-lg transition-colors"
                        title="Voir le relevé"
                      >
                        <Eye size={18} />
                      </button>
                      {timesheet.status === "a_saisir" && (
                        <button
                          onClick={() => {
                            const updatedTimesheets = [...timesheets];
                            const index = updatedTimesheets.findIndex(t => t.id === timesheet.id);
                            if (index !== -1) {
                              updatedTimesheets[index] = { ...updatedTimesheets[index], reminderSent: true };
                              setTimesheets(updatedTimesheets);
                              toast.success(`Relance envoyée pour ${timesheet.employeeName}`);
                            }
                          }}
                          className="p-2 text-orange-600 hover:bg-orange-100 rounded-lg transition-colors"
                          title="Envoyer une relance"
                        >
                          <AlertCircle size={18} />
                        </button>
                      )}
                    </div>
                  </div>
                </motion.div>
              ))}
            </AnimatePresence>
          )}
        </motion.div>
        {/* Pagination moderne */}
        {totalPages > 1 && (
          <motion.div
            className="bg-white rounded-xl shadow-sm border border-slate-200 p-6 mt-8"
            variants={itemVariants}
          >
            <div className="flex flex-col sm:flex-row justify-between items-center gap-4">
              <div className="text-sm text-slate-600">
                Affichage de {startIndex + 1} à {Math.min(endIndex, filteredTimesheets.length)} sur {filteredTimesheets.length} relevés d'heures
              </div>

              <div className="flex items-center space-x-2">
                <button
                  onClick={() => setCurrentPage(Math.max(1, validCurrentPage - 1))}
                  disabled={validCurrentPage === 1}
                  className="p-2 rounded-lg border border-slate-200 text-slate-600 hover:bg-slate-50 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
                >
                  <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
                  </svg>
                </button>

                {totalPages > 0 && Array.from({ length: Math.min(5, totalPages) }, (_, i) => {
                  const pageNum = Math.max(1, Math.min(totalPages - 4, validCurrentPage - 2)) + i;
                  if (pageNum > totalPages) return null;
                  return (
                    <button
                      key={pageNum}
                      onClick={() => setCurrentPage(pageNum)}
                      className={`px-4 py-2 rounded-lg font-medium transition-colors ${
                        validCurrentPage === pageNum
                          ? "bg-blue-500 text-white"
                          : "text-slate-600 hover:bg-slate-100"
                      }`}
                    >
                      {pageNum}
                    </button>
                  );
                })}

                <button
                  onClick={() => setCurrentPage(Math.min(totalPages, validCurrentPage + 1))}
                  disabled={validCurrentPage === totalPages || totalPages === 0}
                  className="p-2 rounded-lg border border-slate-200 text-slate-600 hover:bg-slate-50 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
                >
                  <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                  </svg>
                </button>
              </div>
            </div>
          </motion.div>
        )}
      </motion.div>

      {/* Overlay pour afficher le relevé d'heures */}
      {selectedTimesheetId && (
        <div className="fixed inset-0 z-50 bg-white overflow-auto">
          {/* Bouton de fermeture */}
          <div className="sticky top-0 z-10 bg-white border-b border-slate-200 px-6 py-4 flex justify-between items-center shadow-sm">
            <h2 className="text-xl font-semibold text-slate-800">Relevé d'heures</h2>
            <button
              onClick={closeTimesheetOverlay}
              className="p-2 hover:bg-slate-100 rounded-lg transition-colors"
              title="Fermer"
            >
              <X size={24} className="text-slate-600" />
            </button>
          </div>

          {/* Contenu du relevé d'heures */}
          <div className="p-6">
            <RelevesHeures
              timesheetId={selectedTimesheetId}
              initialTimesheet={selectedTimesheet}
              onClose={closeTimesheetOverlay}
              isOverlay={true}
            />
          </div>
        </div>
      )}
    </div>
  );
}


